import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cs_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;

export function formatDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function trackWhatsAppClick(source, tier, context) {
  try {
    await api.post("/events/whatsapp-click", { source, tier, context });
  } catch (_) {}
}

let cachedWa = null;
export async function getWhatsAppNumber() {
  if (cachedWa) return cachedWa;
  try {
    const { data } = await api.get("/config/whatsapp");
    cachedWa = data.number;
  } catch {
    cachedWa = "919709020257";
  }
  return cachedWa;
}

export async function openWhatsApp({ source, tier, message }) {
  const number = await getWhatsAppNumber();
  await trackWhatsAppClick(source, tier);
  const text = message ||
    (tier
      ? `Hi CaarSaarthi, I'd like to know more about the ${tier} tier. Please assist.`
      : `Hi CaarSaarthi, I'd like buyer-side help for my car purchase. Please guide me.`);
  const url = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
